import {Box} from "@chakra-ui/react";
import PatientHeader from "../components/patientComponent/PatientHeader.tsx";
import PatientTable from "../components/patientComponent/PatientTable.tsx";

function PatientListing() {
    return (
        <Box w="100%">
            {/* Fixed Header */}
            <Box position="fixed" top="100px" left="320" right="8" bg="#F4F7FE">
                <PatientHeader/>
            </Box>

            {/* Scrollable Table */}
            <Box mt="60px">
                <PatientTable/>
            </Box>
        </Box>
    );
}

export default PatientListing;